<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <health-report-surveillance-reason-create-or-update v-model="reason" :errors="errors"></health-report-surveillance-reason-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import HealthReportSurveillanceReasonCreateOrUpdate from './components/HealthReportSurveillanceReasonCreateOrUpdate.vue'
import HealthReportApi from '@/api/health-report'

export default {
    components:{
        BCard,
        HealthReportSurveillanceReasonCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Takip Gerekçesi",key:"Name", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            reason:{
                Id:null,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.reason.Id = null
            this.reason.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HealthReportApi.SurveillanceReason.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.reason.Id = item.Id
            this.reason.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HealthReportApi.SurveillanceReason.CreateOrUpdate(this.editing,this.reason).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} takip gerekçesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HealthReportApi.SurveillanceReason.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>